// Layout constants for consistent sizing across the application
export const LAYOUT_CONSTANTS = {
  // Sidebar and panels
  SIDEBAR_WIDTH: 300,
  RIGHT_PANEL_WIDTH: 200,
  
  // Header and toolbar
  HEADER_HEIGHT: 64,
  TOOLBAR_HEIGHT: 56,
  TOTAL_TOP_HEIGHT: 120, // HEADER_HEIGHT + TOOLBAR_HEIGHT
  
  // Content area
  // 모바일에서는 100%, 데스크탑에서는 사이드바 고려
  CONTENT_WIDTH_CALC: 'calc(100vw - (min(100vw, 768px) < 768px ? 0px : 300px))', // 모바일 100%, 데스크탑 -300px
  CONTENT_HEIGHT_RATIO: 0.95, // 90% of available height
  
  // Minimum sizes
  MIN_SLIDE_WIDTH: 350, // 데스크톱 최소 너비
  MIN_SLIDE_HEIGHT: 200, // 데스크톱 최소 높이
  MIN_SLIDE_HEIGHT_RATIO: 0.5, // 30% of available height (레거시 호환용)
  
  // Mobile minimum sizes (더 작은 값으로 모바일 최적화)
  MOBILE_MIN_SLIDE_WIDTH: 200, // 모바일 최소 너비
  MOBILE_MIN_SLIDE_HEIGHT: 150, // 모바일 최소 높이
  
  // Presentation mode
  PRESENTATION_PADDING: 10,
  PRESENTATION_PADDING_FULLSCREEN: 20,
  PRESENTATION_CONTROLS_HEIGHT: 80,
  
  // Display scale
  DEFAULT_DISPLAY_SCALE: 100,
  MIN_DISPLAY_SCALE: 50,
  MAX_DISPLAY_SCALE: 150,
  
  // Minimum transform scale to prevent slides from becoming too small
  MIN_TRANSFORM_SCALE: 0.8, // 슬라이드가 원본 크기의 50% 이하로 작아지지 않도록 제한
  
  // Slide margins/gaps
  SLIDE_MARGIN: 20, // 모든 방향에 동일한 갭 (px) - 외부 여백
  SLIDE_PADDING: {
    TOP: 20,
    RIGHT: 20,
    BOTTOM: 20,
    LEFT: 20
  },
  // 슬라이드 테두리 내부 갭 (실제 콘텐츠와 테두리 사이)
  SLIDE_BORDER_GAP: 20, // 슬라이드 테두리 내부 패딩 (px)
} as const;